// import React, { Component } from 'react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import {
  Container,
  Grid,
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import NewCreditCheck from '../CreditCheck/NewCreditCheck';
import { fetchM } from '../../actions/fetchM';
import { flashErrorMessage } from '../../actions/flash';

class CreditCheck extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    onCheck: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const loading = props.loading;
    return {
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = CreditCheck.getPropsToState(props);
    this.state = {
      ...state,
      booking: [],
      data: [],
      hasChanges: false,
    };
  }
  componentDidMount() {
    this.fetchBooking();
  }
  componentWillReceiveProps(nextProps) {
    const state = CreditCheck.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  setLoading = (loading = false) => (
    new Promise((res) => {
      this.setState({ loading }, res);
    })
  )
  async fetchBooking() {
    await this.setLoading(false);
    const { store } = this.context;
    let url = '/bookings/';
    if (this.props.params.id) {
      url += `${this.props.params.id}/`;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(url, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      await this.setLoading(false);
      return;
    }
    const json = await res.json();
    if (json) {
      const newBooking = Object.assign({}, json || {});
      this.setState({ booking: newBooking }, () => this.fetchCustomer());
    }
    await this.setLoading(false);
  }
  async fetchCustomer() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/customers/${this.state.booking.customerID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    const json = await res.json();
    if (json) {
      const newData = Object.assign({}, json || {});
      this.setState({ data: newData });
    }
    await this.setLoading(false);
  }
  handleOnCheck = (hasChanges = false) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges);
    }
  }
  handleRefetch = () => {
    const { store } = this.context;
    store.dispatch(push(`/bookings/${this.props.params.id}/credit_check/`));
  }
  pathCheck = (props) => {
    const { pathname } = props.location;
    if (pathname.includes('/bookings/')) {
      return true;
    }
    return false;
  }
  render() {
    const { booking, data } = this.state;
    const { location } = this.props;
    return (
      <Container>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              {
                booking.length !== 0 && data.length !== 0 ? (
                  <NewCreditCheck
                    newHeader="CUSTOMER ASSESSMENT"
                    auth={this.props.auth}
                    bookingID={booking.id}
                    data={data}
                    pathCheck={this.pathCheck(this.props)}
                    loading={this.state.loading}
                    setLoading={this.setLoading}
                    customerID={data.id || ''}
                    onChange={this.handleOnCheck}
                    icFrontDocumentID={data.icFrontDocumentID || ''}
                    icFrontDocument={data.icFrontDocument || null}
                    icBackDocumentID={data.icBackDocumentID || ''}
                    icBackDocument={data.icBackDocument || null}
                    incomeID={data.incomeID || ''}
                    income={data.income || null}
                    customerCreditReport={data.customerCreditReport || null}
                    customerCreditReports={data.customerCreditReports || []}
                    customerDetail={data.customerDetail || null}
                    refetch={this.handleRefetch}
                    identityTypeID={data.identityTypeID || 0}
                    identity={data.identity || ''}
                    location={location}
                  />
                ) : null
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default connect(CreditCheck.mapStateToProps)(CreditCheck);



// WEBPACK FOOTER //
// ./src/containers/Bookings/CreditCheck.jsx